import { Button, DatePicker, Input, Select } from "antd";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { PrintCyclenderInput } from "../../../common/common-functions";
import { ErrorToast, SuccessToast } from "../../../../widgets/AppToast";
import TextArea from "antd/es/input/TextArea";
import { post } from "../../../../services/services";
import { ApiURL } from "../../../../services/apiConstants";
import useUserData from "../../../../hooks/useUserData";
import moment from "moment";
import dayjs from "dayjs";
import { useDate } from "../../../../context/DateContext";

const AuxiliryEngineLog = () => {
  const user = useUserData();
  const { selectedDate } = useDate();
  const { eng_log_basic_id } = useParams();
  const [loader, set_loader] = useState(false);
  const [errors, set_errors] = useState({});
  const [staff_dashboard, set_staff_dashboard] = useState([]);
  const [cyl_fuel_rack, set_cyl_fuel_rack] = useState("");
  const [cyl_exhaust_temp, set_cyl_exhaust_temp] = useState("");
  const [ship_no_of_cylinder, set_ship_no_of_cylinder] = useState(null);
  const [engine_number, set_engine_number] = useState(1);
  const [engine_number_list, set_engine_number_list] = useState([]);
  const [number_of_engines_running, set_number_of_engines_running] =
    useState("");
  const [cooling_water_pressure, set_cooling_water_pressure] = useState("");
  const [cooling_water_temp_in, set_cooling_water_temp_in] = useState("");
  const [lube_oil_pressure, set_lube_oil_pressure] = useState("");
  const [lube_oil_temp_in, set_lube_oil_temp_in] = useState("");
  const [fuel_oil_pressure, set_fuel_oil_pressure] = useState("");
  const [fuel_oil_temp, set_fuel_oil_temp] = useState("");
  const [fuel_Oil_Type, set_Fuel_Oil_Type] = useState("");
  const [other_fuel_oil_type, set_Other_fuel_oil_type] = useState("");
  const [scavenge_air_pressure, set_scavenge_air_pressure] = useState("");
  const [scavenge_air_temp, set_scavenge_air_temp] = useState("");
  const [alternator_bearing_pressure, set_alternator_bearing_pressure] =
    useState("");
  const [alternator_bearing_temp, set_alternator_bearing_temp] = useState("");
  const [running_Hour, set_Running_Hour] = useState("");
  const [total_Running_Hour, set_Total_Running_Hour] = useState("");
  const [free_Text, set_Free_Text] = useState("");
  const [update_status, set_update_status] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(false);
  const [auxi_exhaust_temp, set_auxi_exhaust_temp] = useState({
    max: null,
    orange: null,
    red: null,
  });
  const [logDate, set_LogDate] = useState(
    moment().format("YYYY-MM-DD HH:mm:ss")
  );
  const [load_kw, set_load_kw] = useState("");
  const [turbocharger_rpm, set_turbocharger_rpm] = useState("");

  const VIEW_ALARM_API = () => {
    try {
      const FORM_DATA = new FormData();
      post(ApiURL.view_alarm_conditions_st, FORM_DATA).then((res) => {
        const alarm_condition_data = res?.alarm_condition_data;
        if (res?.status == true && alarm_condition_data) {
          set_auxi_exhaust_temp(
            JSON.parse(alarm_condition_data.auxi_exhaust_temp)
          );
        } else {
          const errors = res?.errors || {};
          set_errors(errors);
        }
      });
    } finally {
    }
  };

  const ADD_AUXILIRY_DETAILS_LOGBOOK_API = async () => {
    try {
      set_loader(true);
      const FORM_DATA = new FormData();
      FORM_DATA.append(
        "date_time_log",
        logDate || moment(new Date()).format("YYYY-MM-DD HH:mm:ss")
      );
      FORM_DATA.append("eng_log_basic_id", Number(eng_log_basic_id) || 0);
      FORM_DATA.append(
        "voyage_id",
        Number(staff_dashboard?.voyage_details?.[0]?.id) || 0
      );
      FORM_DATA.append(
        "cyl_fuel_rack",
        Array.isArray(cyl_fuel_rack)
          ? JSON.stringify(cyl_fuel_rack)
          : Number(cyl_fuel_rack) || 0
      );
      FORM_DATA.append(
        "cyl_exhaust_temp",
        Array.isArray(cyl_exhaust_temp)
          ? JSON.stringify(cyl_exhaust_temp)
          : Number(cyl_exhaust_temp) || 0
      );
      FORM_DATA.append("engine_number", Number(engine_number) || 0);
      FORM_DATA.append(
        "number_of_engines_running",
        Number(number_of_engines_running) || 0
      );
      FORM_DATA.append(
        "cooling_water_pressure",
        Number(cooling_water_pressure) || 0
      );
      FORM_DATA.append(
        "cooling_water_temp_in",
        Number(cooling_water_temp_in) || 0
      );
      FORM_DATA.append("lube_oil_pressure", Number(lube_oil_pressure) || 0);
      FORM_DATA.append("lube_oil_temp_in", Number(lube_oil_temp_in) || 0);
      FORM_DATA.append("fuel_oil_pressure", Number(fuel_oil_pressure) || 0);
      FORM_DATA.append("fuel_oil_temp", Number(fuel_oil_temp) || 0);
      FORM_DATA.append(
        "scavenge_air_pressure",
        Number(scavenge_air_pressure) || 0
      );
      FORM_DATA.append("scavenge_air_temp", Number(scavenge_air_temp) || 0);
      FORM_DATA.append(
        "alternator_bearing_pressure",
        Number(alternator_bearing_pressure) || 0
      );
      FORM_DATA.append(
        "alternator_bearing_temp",
        Number(alternator_bearing_temp) || 0
      );
      FORM_DATA.append("auxiliary_running_hours", Number(running_Hour) || 0);
      FORM_DATA.append(
        "auxiliary_total_running_hours",
        Number(total_Running_Hour) || 0
      );
      FORM_DATA.append("fuel_Oil_Type", fuel_Oil_Type || "");
      FORM_DATA.append("other_fuel_oil_type", other_fuel_oil_type || "");
      FORM_DATA.append("auxi_comment", free_Text || "");
      FORM_DATA.append("load_kw", load_kw || "");
      FORM_DATA.append("turbocharger_rpm", turbocharger_rpm || "");

      post(ApiURL.add_auxiliary_eng_log_st, FORM_DATA).then((res) => {
        if (res?.status == true) {
          SuccessToast("Logbook Add Success!", res?.message);
          set_loader(false);
          VIEW_AUXILARY_ENGINE_DETAILS_LOGBOOK_API(staff_dashboard);
        } else {
          set_loader(false);
          const errors = res?.errors || {};
          set_errors(errors);
        }
      });
    } catch (error) {
      console.error("Error Adding logbook:", error);
    } finally {
    }
  };

  const UPDATE_AUXILIRY_DETAILS_LOGBOOK_API = async (save_submit) => {
    try {
      set_loader(true);
      const FORM_DATA = new FormData();
      FORM_DATA.append(
        "date_time_log",
        logDate || moment(new Date()).format("YYYY-MM-DD HH:mm:ss")
      );
      FORM_DATA.append("save_submit", Number(save_submit) || 0);
      FORM_DATA.append("eng_log_basic_id", Number(eng_log_basic_id));
      FORM_DATA.append(
        "voyage_id",
        Number(staff_dashboard?.voyage_details?.[0]?.id)
      );
      FORM_DATA.append(
        "cyl_fuel_rack",
        Array.isArray(cyl_fuel_rack)
          ? JSON.stringify(cyl_fuel_rack)
          : Number(cyl_fuel_rack)
      );
      FORM_DATA.append(
        "cyl_exhaust_temp",
        Array.isArray(cyl_exhaust_temp)
          ? JSON.stringify(cyl_exhaust_temp)
          : Number(cyl_exhaust_temp)
      );
      FORM_DATA.append("engine_number", Number(engine_number));
      FORM_DATA.append(
        "number_of_engines_running",
        Number(number_of_engines_running)
      );
      FORM_DATA.append(
        "cooling_water_pressure",
        Number(cooling_water_pressure)
      );
      FORM_DATA.append("cooling_water_temp_in", Number(cooling_water_temp_in));
      FORM_DATA.append("lube_oil_pressure", Number(lube_oil_pressure));
      FORM_DATA.append("lube_oil_temp_in", Number(lube_oil_temp_in));
      FORM_DATA.append("fuel_oil_pressure", Number(fuel_oil_pressure));
      FORM_DATA.append("fuel_oil_temp", Number(fuel_oil_temp));
      FORM_DATA.append("scavenge_air_pressure", Number(scavenge_air_pressure));
      FORM_DATA.append("scavenge_air_temp", Number(scavenge_air_temp));
      FORM_DATA.append(
        "alternator_bearing_pressure",
        Number(alternator_bearing_pressure)
      );
      FORM_DATA.append(
        "alternator_bearing_temp",
        Number(alternator_bearing_temp)
      );
      FORM_DATA.append("auxiliary_running_hours", Number(running_Hour));
      FORM_DATA.append(
        "auxiliary_total_running_hours",
        Number(total_Running_Hour)
      );
      FORM_DATA.append("fuel_Oil_Type", fuel_Oil_Type || "");
      FORM_DATA.append("other_fuel_oil_type", other_fuel_oil_type || "");
      FORM_DATA.append("auxi_comment", free_Text);
      FORM_DATA.append("load_kw", load_kw || "");
      FORM_DATA.append("turbocharger_rpm", turbocharger_rpm || "");

      post(ApiURL.view_update_auxiliary_eng_log_st, FORM_DATA).then((res) => {
        if (res?.status == true) {
          SuccessToast("Logbook Update Success!", res?.message);
          set_loader(false);
          VIEW_AUXILARY_ENGINE_DETAILS_LOGBOOK_API(staff_dashboard);
        } else {
          set_loader(false);
          ErrorToast(
            "Error message",
            "Submission failed! Please fill in all required fields and try again."
          );
          const errors = res?.response?.data?.errors || {};
          set_errors(errors);
        }
      });
    } catch (error) {
      console.error("Error updating logbook:", error);
    } finally {
    }
  };

  const VIEW_AUXILARY_ENGINE_DETAILS_LOGBOOK_API = async (voyage_id) => {
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("eng_log_basic_id", eng_log_basic_id);
      FORM_DATA.append("voyage_id", voyage_id?.voyage_details?.[0]?.id);
      FORM_DATA.append("engine_number", engine_number);
      post(ApiURL.view_update_auxiliary_eng_log_st, FORM_DATA).then((res) => {
        const auxiliary_Engine = res?.response_data;
        if (res?.status == true) {
          const local_user = JSON.parse(localStorage.getItem("user_data"));
          const cyl = local_user?.data?.ship_details?.auxiliary_no_of_cylinder;
          set_cyl_exhaust_temp(
            auxiliary_Engine?.cyl_exhaust_temp
              ? JSON.parse(auxiliary_Engine?.cyl_exhaust_temp)
              : Array(cyl).fill("")
          );
          set_cyl_fuel_rack(
            auxiliary_Engine?.cyl_fuel_rack
              ? JSON.parse(auxiliary_Engine?.cyl_fuel_rack)
              : Array(cyl).fill("")
          );
          // set_engine_number(auxiliary_Engine?.engine_number);
          set_number_of_engines_running(
            auxiliary_Engine?.number_of_engines_running
          );
          set_update_status(auxiliary_Engine?.complete_status);
          set_cooling_water_pressure(auxiliary_Engine?.cooling_water_pressure);
          set_cooling_water_temp_in(auxiliary_Engine?.cooling_water_temp_in);
          set_lube_oil_pressure(auxiliary_Engine?.lube_oil_pressure);
          set_lube_oil_temp_in(auxiliary_Engine?.lube_oil_temp_in);
          set_fuel_oil_pressure(auxiliary_Engine?.fuel_oil_pressure);
          set_fuel_oil_temp(auxiliary_Engine?.fuel_oil_temp);
          set_scavenge_air_pressure(auxiliary_Engine?.scavenge_air_pressure);
          set_scavenge_air_temp(auxiliary_Engine?.scavenge_air_temp);
          set_alternator_bearing_pressure(
            auxiliary_Engine?.alternator_bearing_pressure
          );
          set_alternator_bearing_temp(
            auxiliary_Engine?.alternator_bearing_temp
          );
          set_Running_Hour(auxiliary_Engine?.auxiliary_running_hours);
          set_Total_Running_Hour(
            auxiliary_Engine?.auxiliary_total_running_hours
          );
          set_Free_Text(auxiliary_Engine?.auxi_comment);
          set_Fuel_Oil_Type(auxiliary_Engine?.fuel_Oil_Type);
          set_Other_fuel_oil_type(auxiliary_Engine?.other_fuel_oil_type);
          setSubmitStatus(res?.submit_status);
          set_LogDate(auxiliary_Engine?.date_time_log);
          set_ship_no_of_cylinder(res?.auxi_eng_cylinder);
          set_load_kw(auxiliary_Engine?.load_kw || "");
          set_turbocharger_rpm(auxiliary_Engine?.turbocharger_rpm || "");
          set_engine_number_list(res?.auxiliary_Engine_number);
        } else {
          const errors = res?.errors || {};
          set_errors(errors);
        }
      });
    } catch (error) {
      console.error("Error View auxiliary Engine logbook:", error);
    }
  };

  useEffect(() => {
    const staff_dashboards = localStorage.getItem("staff_dashboard");
    const parsedData = JSON.parse(staff_dashboards);
    const userData = JSON.parse(localStorage.getItem("user_data"));
    set_ship_no_of_cylinder(
      userData?.data?.ship_details?.auxiliary_no_of_cylinder
    );
    set_staff_dashboard(parsedData);
    if (parsedData) {
      VIEW_AUXILARY_ENGINE_DETAILS_LOGBOOK_API(parsedData);
    }
    VIEW_ALARM_API();
  }, []);

  useEffect(() => {
    const voyageId = staff_dashboard?.voyage_details?.[0]?.id;
    if (voyageId && engine_number) {
      VIEW_AUXILARY_ENGINE_DETAILS_LOGBOOK_API(staff_dashboard);
    }
  }, [engine_number]);

  const onChangeDateTime = (value) => {
    if (value) {
      set_LogDate(value.format("YYYY-MM-DD HH:mm:ss"));
    } else {
      set_LogDate(null);
    }
  };

  return (
    <>
      <div className="white-container">
        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>Date & Time</label>
              <DatePicker
                disabled
                showTime
                format="YYYY-MM-DD HH:mm:ss"
                placeholder="Select Date & Time"
                // value={logDate ? dayjs(logDate, "YYYY-MM-DD HH:mm:ss") : null}
                value={
                  update_status && logDate
                    ? dayjs(logDate, "YYYY-MM-DD HH:mm:ss")
                    : selectedDate
                    ? dayjs(selectedDate, "YYYY-MM-DD HH:mm:ss")
                    : null
                }
                onChange={onChangeDateTime}
                style={{ width: "100%" }}
              />
              {errors?.date_time_log && (
                <span style={{ color: "red" }}>{errors?.date_time_log}</span>
              )}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>Auxiliary Engine Number</label>
              <Select
                disabled={submitStatus}
                value={engine_number}
                placeholder=" -- Select of Auxiliary Engine Number  -- "
                style={{ width: "100%" }}
                onChange={(value) => {
                  set_engine_number(value);
                }}
              >
                {engine_number_list?.map((number) => (
                  <Select.Option key={number} value={number}>
                    {number}
                  </Select.Option>
                ))}
              </Select>
              {errors?.engine_number && (
                <>
                  <span style={{ color: "red" }}>{errors?.engine_number}</span>
                </>
              )}
            </div>
          </div>
          <div className="col-6">
            <div className="input-box">
              <label>Number of Engines Running</label>
              <Input
                disabled={submitStatus}
                value={number_of_engines_running}
                placeholder="Number of Engines Running"
                onChange={(e) => {
                  set_number_of_engines_running(e.target.value);
                }}
              />
              {errors?.number_of_engines_running && (
                <span style={{ color: "red" }}>
                  {errors?.number_of_engines_running}
                </span>
              )}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>Exhaust Temperature (°C)</label>
              <div
                className="row"
                style={{
                  margin: "0px 0px",
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "10px",
                }}
              >
                <PrintCyclenderInput
                  placeholder="Temp"
                  input_number={ship_no_of_cylinder}
                  disabled={submitStatus}
                  set_value={set_cyl_exhaust_temp}
                  values={cyl_exhaust_temp}
                  alarm_Data={auxi_exhaust_temp}
                />
              </div>
              {errors?.cyl_exhaust_temp && (
                <>
                  <span style={{ color: "red" }}>
                    {errors?.cyl_exhaust_temp}
                  </span>
                </>
              )}
            </div>
          </div>
          {/* Fuel Rack */}
          <div className="col-6">
            <div className="input-box">
              <label>Fuel Rack</label>
              <div
                className="row"
                style={{
                  margin: "0px 0px",
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "10px",
                }}
              >
                <PrintCyclenderInput
                  placeholder="Rack"
                  disabled={submitStatus}
                  input_number={ship_no_of_cylinder}
                  set_value={set_cyl_fuel_rack}
                  values={cyl_fuel_rack}
                  // alarm_Data={fuel_rack}
                />
              </div>
              {errors?.cyl_fuel_rack && (
                <span style={{ color: "red" }}>{errors?.cyl_fuel_rack}</span>
              )}
            </div>
          </div>
        </div>

        {/*Load KW */}
        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>Running Hour</label>
              <Input
                disabled={submitStatus}
                value={running_Hour}
                placeholder="Running Hour "
                onChange={(e) => set_Running_Hour(e.target.value)}
              />
              {errors?.auxiliary_running_hours && (
                <>
                  <span style={{ color: "red" }}>
                    {errors?.auxiliary_running_hours}
                  </span>
                </>
              )}
            </div>
          </div>
          {/* Total Running Hour */}
          <div className="col-6">
            <div className="input-box">
              <label>Total Running Hour</label>
              <Input
                disabled={submitStatus}
                value={total_Running_Hour}
                placeholder="Total Running Hour"
                onChange={(e) => {
                  set_Total_Running_Hour(e.target.value);
                }}
              />
              {errors?.auxiliary_total_running_hours && (
                <span style={{ color: "red" }}>
                  {errors?.auxiliary_total_running_hours}
                </span>
              )}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>Load (KW)</label>
              <Input
                disabled={submitStatus}
                value={load_kw}
                placeholder="Load (KW)"
                onChange={(e) => set_load_kw(e.target.value)}
              />
              {errors?.load_kw && (
                <>
                  <span style={{ color: "red" }}>{errors?.load_kw}</span>
                </>
              )}
            </div>
          </div>
          {/* Turbocharger RPM */}
          <div className="col-6">
            <div className="input-box">
              <label>Turbocharger (RPM)</label>
              <Input
                disabled={submitStatus}
                value={turbocharger_rpm}
                placeholder="Turbocharger (RPM)"
                onChange={(e) => {
                  set_turbocharger_rpm(e.target.value);
                }}
              />
              {errors?.turbocharger_rpm && (
                <span style={{ color: "red" }}>{errors?.turbocharger_rpm}</span>
              )}
            </div>
          </div>
        </div>

        {/* Cooling Water */}
        <h3>Cooling Water</h3>
        <div className="row">
          {/* Pressure */}
          <div className="col-6">
            <div className="input-box">
              <label>Pressure (Bar)</label>
              <Input
                disabled={submitStatus}
                value={cooling_water_pressure}
                placeholder="Cooling water pressure (Bar)"
                onChange={(e) => {
                  set_cooling_water_pressure(e.target.value);
                }}
              />
              {errors?.cooling_water_pressure && (
                <>
                  <span style={{ color: "red" }}>
                    {errors?.cooling_water_pressure}
                  </span>
                </>
              )}
            </div>
          </div>
          {/* Tempreture  */}
          <div className="col-6">
            <div className="input-box">
              <label>Temperature (°C)</label>
              <Input
                disabled={submitStatus}
                value={cooling_water_temp_in}
                placeholder="Cooling Water Temperature (°C)"
                onChange={(e) => {
                  set_cooling_water_temp_in(e.target.value);
                }}
              />
              {errors?.cooling_water_temp_in && (
                <span style={{ color: "red" }}>
                  {errors?.cooling_water_temp_in}
                </span>
              )}
            </div>
          </div>
        </div>

        {/* Lube Oil */}
        <h3>Lube Oil</h3>
        <div className="row">
          {/* Pressure */}
          <div className="col-6">
            <div className="input-box">
              <label>Pressure (Bar)</label>
              <Input
                disabled={submitStatus}
                value={lube_oil_pressure}
                placeholder="Cooling water pressure (Bar)"
                onChange={(e) => {
                  set_lube_oil_pressure(e.target.value);
                }}
              />
              {errors?.lube_oil_pressure && (
                <>
                  <span style={{ color: "red" }}>
                    {errors?.lube_oil_pressure}
                  </span>
                </>
              )}
            </div>
          </div>
          {/* Tempreture  */}
          <div className="col-6">
            <div className="input-box">
              <label>Temperature (°C)</label>
              <Input
                disabled={submitStatus}
                value={lube_oil_temp_in}
                placeholder="Cooling Water Temperature (°C)"
                onChange={(e) => {
                  set_lube_oil_temp_in(e.target.value);
                }}
              />
              {errors?.lube_oil_temp_in && (
                <span style={{ color: "red" }}>{errors?.lube_oil_temp_in}</span>
              )}
            </div>
          </div>
        </div>
        {/* Fuel Oil */}
        <h3>Fuel Oil</h3>
        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>Fuel Oil Type</label>
              <Select
                disabled={submitStatus}
                value={fuel_Oil_Type}
                placeholder=" -- Select of  Fuel Oil Type  -- "
                style={{ width: "100%" }}
                onChange={(value) => set_Fuel_Oil_Type(value)}
              >
                <Select.Option value="VLSFO">VLSFO</Select.Option>
                <Select.Option value="LSMGO">LSMGO</Select.Option>
                <Select.Option value="HSFO">HSFO</Select.Option>
                <Select.Option value="Other">Other</Select.Option>
              </Select>
              {errors?.fuel_Oil_Type && (
                <>
                  <span style={{ color: "red" }}>{errors?.fuel_Oil_Type}</span>
                </>
              )}
            </div>
          </div>
          {fuel_Oil_Type === "Other" && (
            <>
              <div className="col-6">
                <div className="input-box">
                  <label>Other fuel oil type</label>
                  <Input
                    disabled={submitStatus}
                    value={other_fuel_oil_type}
                    placeholder="Other fuel oil type"
                    onChange={(e) => {
                      set_Other_fuel_oil_type(e.target.value);
                    }}
                  />
                  {errors?.other_fuel_oil_type && (
                    <span style={{ color: "red" }}>
                      {errors?.other_fuel_oil_type}
                    </span>
                  )}
                </div>
              </div>
            </>
          )}
        </div>
        <div className="row">
          {/* Pressure */}
          <div className="col-6">
            <div className="input-box">
              <label>Pressure (Bar)</label>
              <Input
                disabled={submitStatus}
                value={fuel_oil_pressure}
                placeholder="Fuel Oil pressure (Bar)"
                onChange={(e) => {
                  set_fuel_oil_pressure(e.target.value);
                }}
              />
              {errors?.fuel_oil_pressure && (
                <>
                  <span style={{ color: "red" }}>
                    {errors?.fuel_oil_pressure}
                  </span>
                </>
              )}
            </div>
          </div>
          {/* Tempreture  */}
          <div className="col-6">
            <div className="input-box">
              <label>Temperature (°C)</label>
              <Input
                disabled={submitStatus}
                value={fuel_oil_temp}
                placeholder="Fuel Oil Temperature (°C)"
                onChange={(e) => {
                  set_fuel_oil_temp(e.target.value);
                }}
              />
              {errors?.fuel_oil_temp && (
                <span style={{ color: "red" }}>{errors?.fuel_oil_temp}</span>
              )}
            </div>
          </div>
        </div>
        {/* Scavenge Air */}
        <h3>Scavenge Air </h3>
        <div className="row">
          {/* Pressure */}
          <div className="col-6">
            <div className="input-box">
              <label>Pressure (Bar)</label>
              <Input
                disabled={submitStatus}
                value={scavenge_air_pressure}
                placeholder="Scavenge Air Pressure (Bar)"
                onChange={(e) => {
                  set_scavenge_air_pressure(e.target.value);
                }}
              />
              {errors?.scavenge_air_pressure && (
                <>
                  <span style={{ color: "red" }}>
                    {errors?.scavenge_air_pressure}
                  </span>
                </>
              )}
            </div>
          </div>
          {/* Tempreture  */}
          <div className="col-6">
            <div className="input-box">
              <label>Temperature (°C)</label>
              <Input
                disabled={submitStatus}
                value={scavenge_air_temp}
                placeholder="Scavenge Air Temperature (°C)"
                onChange={(e) => {
                  set_scavenge_air_temp(e.target.value);
                }}
              />
              {errors?.scavenge_air_temp && (
                <span style={{ color: "red" }}>
                  {errors?.scavenge_air_temp}
                </span>
              )}
            </div>
          </div>
        </div>
        {/* Alternator Bearing */}
        <h3>Alternator Bearing </h3>
        <div className="row">
          {/* Pressure */}
          <div className="col-6">
            <div className="input-box">
              <label>Pressure (Bar)</label>
              <Input
                disabled={submitStatus}
                value={alternator_bearing_pressure}
                placeholder="Alternator Bearing  Pressure (Bar)"
                onChange={(e) => {
                  set_alternator_bearing_pressure(e.target.value);
                }}
              />
              {errors?.alternator_bearing_pressure && (
                <>
                  <span style={{ color: "red" }}>
                    {errors?.alternator_bearing_pressure}
                  </span>
                </>
              )}
            </div>
          </div>
          {/* Tempreture  */}
          <div className="col-6">
            <div className="input-box">
              <label>Temperature (°C)</label>
              <Input
                disabled={submitStatus}
                value={alternator_bearing_temp}
                placeholder="Alternator Bearing  Temperature (°C)"
                onChange={(e) => {
                  set_alternator_bearing_temp(e.target.value);
                }}
              />
              {errors?.alternator_bearing_temp && (
                <span style={{ color: "red" }}>
                  {errors?.alternator_bearing_temp}
                </span>
              )}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>Auxiliary Engine comments</label>
              <TextArea
                rows={6}
                placeholder="Auxiliary Engine comments"
                maxLength={1000}
                disabled={submitStatus}
                value={free_Text}
                onChange={(e) => set_Free_Text(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="row">
          {user?.data?.designation === "Chief Engineer" && eng_log_basic_id && (
            <div className="input-box" style={{ marginTop: "15px" }}>
              <Button
                disabled={submitStatus}
                loading={loader}
                className="save_btn"
                style={{ color: "white" }}
                onClick={
                  update_status
                    ? () => UPDATE_AUXILIRY_DETAILS_LOGBOOK_API("1")
                    : () => ADD_AUXILIRY_DETAILS_LOGBOOK_API()
                }
              >
                Submit
              </Button>
            </div>
          )}
          <div className="input-box" style={{ marginTop: "15px" }}>
            <Button
              disabled={submitStatus}
              loading={loader}
              className="save_btn"
              style={{ color: "white", marginLeft: "10px" }}
              onClick={
                update_status
                  ? () => UPDATE_AUXILIRY_DETAILS_LOGBOOK_API("0")
                  : () => ADD_AUXILIRY_DETAILS_LOGBOOK_API()
              }
            >
              Save
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default AuxiliryEngineLog;
